import React, { Component } from "react";
import { connect } from "react-redux";

import { createCurrency } from "actions/currency";
import { toggleFullPageSpinner, toggleNotification } from "actions/toggle";

import Form from "pages/Currencies/Form";

class CurrencyCreate extends Component {
  handleFormSubmit = (data) => {
    const { activeCompany } = this.props;

    data = Object.assign({}, data, { company_url: activeCompany.url });
    this.createCurrency(data);
  };

  createCurrency(data) {
    const {
      toggleNotification,
      activeCompany,
      toggleFullPageSpinner,
      createCurrency,
      history,
    } = this.props;

    toggleFullPageSpinner(true);

    createCurrency(data)
      .then(() => {
        toggleNotification(true, {
          message: "Created Currency Success",
          infoClassName: "is-success",
        });
        history.push(`/${activeCompany.url}/currencies`);
      })
      .catch((e) => {
        toggleNotification(true, {
          message: e.message,
          infoClassName: "is-danger",
        });
      })
      .then(() => toggleFullPageSpinner(false));
  }

  render() {
    const { activeCompany } = this.props;

    return (
      <Form
        handleFormSubmit={this.handleFormSubmit}
        activeCompany={activeCompany}
      />
    );
  }
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {
  createCurrency,
  toggleFullPageSpinner,
  toggleNotification,
})(CurrencyCreate);
